var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useRef } from 'react';

import { Translate } from "../../../../I18N";

import { withDnD } from "../../componentWrappers";













/* eslint-disable comma-spacing */
const DropZoneComponent = ({
  name,
  useDrop = () => {},
  type,
  context,
  parent,
  children,
  wrapperType = 'div',
  className,
  activeClassName,
  innerRef
}) => {
  const ref = useRef(null);
  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: type,
    drop: () => ({ name, context, parent }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  }));

  const isActive = canDrop && isOver;

  const classesByTag = {
    div:
    className ||
    'flex flex-col items-center justify-center  text-gray-400 uppercase p-15 h-14 text-base m-5 border border-gray-300 border-dashed rounded-sm cursor-pointer bg-gray-50',
    tr: className || '',
    'active-div':
    activeClassName ||
    ' bg-gray-800 dark:bg-gray-700 bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600',
    'active-tr': activeClassName || ''
  };

  const baseClassName = classesByTag[wrapperType] || '';
  const activeClasses = classesByTag[`active-${wrapperType}`] || '';
  const dropClassName = isActive ? baseClassName + activeClasses : className || baseClassName;

  const TagName = wrapperType;

  return /*#__PURE__*/(
    React.createElement(TagName, { ref: drop(innerRef || ref), className: dropClassName, "data-testid": name },
    children || /*#__PURE__*/_jsx(Translate, {}, void 0, "Drag items here")
    ));

};
const DropZone = withDnD(DropZoneComponent);
export { DropZone };